import Vue from "vue"
// import {store} from "./store.js"

import * as firebase from "firebase";
import firebaseui from "firebaseui";

export const firebaseConfig = {
	apiKey: "AIzaSyBZ4B1yt_qpfhQdeOaj_ZF6EzS52H9YmZo",
	authDomain: "koonys-quizzes.firebaseapp.com",
	databaseURL: "https://koonys-quizzes.firebaseio.com",
    // projectId: "koonys-quizzes",
    // storageBucket: "koonys-quizzes.appspot.com",
    // messagingSenderId: "972942839312"
};

export const firebaseUiConfig = {
	callbacks: {
		signInSuccess: obj => {
			console.log("Erfolgreich eingeloggt.", obj);

			console.log('signInSuccess: ', obj.providerData[0])

			// firebase.database().ref('/users/' + obj.uid).set({
			// 	...obj.providerData[0]
			// })

			firebase.database().ref('/users/' + obj.uid).once('value').then( snap => {
				console.log('Hier..xx', snap.val())
				if(snap.val() == null){
					console.log('User wird neu gespeichert.')
					firebase.database().ref('/users/' + obj.uid).set({
						...obj.providerData[0]
					})
				}else{
					console.log('User gab es schon.')
				}
			})

			console.log('Hier..')
			return false;

			// window.location.replace('/')
			
		}
	},
	signInFlow: "popup",
	credentialHelper: firebaseui.auth.CredentialHelper.NONE,
	signInOptions: [
	firebase.auth.GoogleAuthProvider.PROVIDER_ID,
	firebase.auth.PhoneAuthProvider.PROVIDER_ID,
	firebase.auth.FacebookAuthProvider.PROVIDER_ID,
	firebase.auth.TwitterAuthProvider.PROVIDER_ID,
         // firebaseApp.auth.GithubAuthProvider.PROVIDER_ID,
         firebase.auth.EmailAuthProvider.PROVIDER_ID
         ],
         tosUrl: "http://www.koonys.de"
     }



// WEBPACK FOOTER //
// ./src/database.js